import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter } from 'react-router-dom';
import { myReducer } from './context/reducers';
import { createStore } from 'redux';
import { Provider } from 'react-redux';
import { myStore, persistor } from './context/store';
import { PersistGate } from 'redux-persist/integration/react';

const root = ReactDOM.createRoot(document.getElementById('root'));

// const myStore=createStore(myReducer, window.__REDUX_DEVTOOLS_EXTENSION__ && window.__REDUX_DEVTOOLS_EXTENSION__())
root.render(
  <React.StrictMode>
   
    <Provider store={myStore}>
        <PersistGate loading={null} persistor={persistor}>
        <BrowserRouter>
          <App />
          </BrowserRouter>
        </PersistGate>
      </Provider>
    
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
